import {
    clearDiagnosisMatch,
    createClientDiagnosis,
    deleteClientDiagnosis,
    editClientDiagnosis,
    getClientDiagnoses,
    getDiagnosisMatch,
    setPrimaryClientDiagnosis,
} from './clientDiagnosis.action';
export { clientDiagnosisReducer } from './clientDiagnosis.reducer';
export { watchClientDiagnosis } from './clientDiagnosis.saga';

export const clientDiagnosisActions = {
    getClientDiagnoses,
    createClientDiagnosis,
    editClientDiagnosis,
    setPrimaryClientDiagnosis,
    deleteClientDiagnosis,
    getDiagnosisMatch,
    clearDiagnosisMatch,
};
